export function getWithExpiry(key) {
	const item = localStorage.getItem(key)
	if (!item) {
		return false
	}
	const itemExpiration = localStorage.getItem(key + "Expire")
	const now = Date.now()
	if (itemExpiration <= now) {
		localStorage.removeItem(key)
		return false
	}
	return item
}

export function setObjectLocalStorage(object = {}) {
	Object.keys(object).forEach((item) => {
		localStorage.setItem(item, object[item])
	})
}

export function setObjectLocalStorageCondition(object = {}, condition) {
	if (condition) {
		setObjectLocalStorage(object)
	}
}

export function clearTokensFromLocalStorage() {
	const tokens = [
		"accessId",
		"accessIdExpire",
		"refreshId",
		"refreshIdExpire"
	]
	tokens.forEach((token) => {
		localStorage.removeItem(token)
	})
}
